import { render } from "./DocumentItem.vue?vue&type=template&id=d74f9e34"
import script from "./DocumentItem.vue?vue&type=script&lang=js"
export * from "./DocumentItem.vue?vue&type=script&lang=js"

import "./DocumentItem.vue?vue&type=style&index=0&id=d74f9e34&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__